<template>
  <div ref="GRAPH_SECTION">
    <section-header ref="GRAPH_DIALOG"
                    :ressource="ressource"
                    :isExtended="true"
                    :dialog="true"
                    @closeDialog=closeDialog>
    </section-header>

    <div>
      <graph-control ref="GRAPH_CONTROL"
                     :obj=obj
                     :objType="cloneGraphData.objType"
                     :firstQuestion="firstQuestion"
                     :value=graphAnswers
                     @input="(value) => setGraphAnswer(value)"
                     @status="statusGraph"
                     @setMinimum="setMinimum"
                     @hasGraph="hasGraph">
      </graph-control>

      <div class="d-flex flex-row-reverse">
        <loader-button class="ms-2"
                       :label="saveLabel"
                       @callback="save">
        </loader-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import { AppSections, RessourceAppSection } from '@/ressources/globalRessources';
import { FwkButtons, RessourceFwkButton } from '@/ressources/globalRessources';
import GraphControl from '@/framework/graph/components/GraphControl.vue';
import GraphData, { GraphAnswer, GraphMinimum } from '@/generated/classes/GraphData';
import { FieldStatus } from '@/framework/base/components/FieldInfo';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  components: {
    SectionHeader,
    GraphControl,
    LoaderButton
  },
  props: {
    graphData: {
      type: Object as PropType<GraphData>,
      required: true
    }
  },
  created() {
    this.objet = JSON.parse(this.cloneGraphData.obj);
  },
  data() {
    const graphStatus: FieldStatus = new FieldStatus(false, false, 0);
    const objet: any = undefined;
    const cloneGraphData = GraphData.fromJson(this.graphData);

    return {
      useGraph: true,
      objet,
      graphStatus,
      cloneGraphData
    };
  },
  computed: {
    ressource() {
      return RessourceAppSection(AppSections.GRAPH_DIALOG);
    },
    saveLabel() {
      return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
    },
    obj() {
      return this.objet;
    },
    firstQuestion(): string {
      return this.cloneGraphData.firstQuestion;
    },
    graphAnswers(): GraphAnswer[] {
      return this.objet.graphAnswers;
    }
  },

  methods: {
    setGraphAnswer(value: GraphAnswer[]) {
      value.forEach((answer) => {
        const oldValues = this.objet.graphAnswers as GraphAnswer[];
        const oldValue = oldValues.find(a => a.code == answer.code);
        if (oldValue) {
          oldValue.label = answer.label;
          oldValue.value = answer.value;
        } else {
          oldValues.push(answer);
        }
      })
    },
    statusGraph(value: FieldStatus): void {
      this.graphStatus = value;
    },
    hasGraph(value: boolean) {
      this.useGraph = value;
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    setMinimum(value: GraphMinimum) {
      this.cloneGraphData.minimum = value;
    },
    save() {
      // @ts-expect-error : generated method
      if (this.$refs.GRAPH_CONTROL) this.$refs.GRAPH_CONTROL.touch();
      if (!this.graphStatus.error) {
        this.cloneGraphData.obj = JSON.stringify(this.objet);
        GraphData.setAdditionalData(this.cloneGraphData);
        this.$emit('closeDialog');
      }
    }
  }
})

</script>
